/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Input,
  Spin,
  Card,
  DatePicker,
  Typography,
} from 'antd';
import { formatReceivedValues } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import { getModelPermission } from 'utils/permission';
import Select from 'components/Select';
import {
  getEstadosGlobales, getTiposDeNomina,
} from 'api/catalogos/index';
import {
  PARAMETRO_AREA,
  PARAMETRO_REEMBOLSOGASTOS,
  PARAMETRO_ESPECIALES,
  PARAMETRO_DESTAJO,
  PARAMETRO_PUESTO,
  PARAMETRO_DEVOLUCION_DESCUENTOS_INDEBIDOS,
  PARAMETRO_RETROACTIVOS_ESPECIFICOS,
  PARAMETRO_ISR_SUBSIDIADO,

  ESTATUS_ACTIVO,
  ESTATUS_AUTORIZADO,
  ESTATUS_INACTIVO,
  ESTATUS_CANCELADO,
} from 'utils/constants';
import {
  getSolicitudesPercepciones,
  postSolicitudPercepcion,
  deleteSolicitudPercepcion,
  patchSolicitudPercepcion,
  getSolicitudPercepcion,
} from 'api/nominas/solicitudes/solicitudesPercepciones';
import { getParametrosDeSolicitudes } from 'api/nominas/solicitudes/solicitudesParametros';
import { getPercepciones } from 'api/nominas/percepciones/percepciones';
import { getPeriodicidadDePercepciones } from 'api/nominas/percepciones/periodicidadDePercepciones';
import { getPeriodosDeNominasDetalles } from 'api/nominas/periodos/periodosDeNominasDetalle';
import { getPeriodosDeNominas } from 'api/nominas/periodos/periodosDeNominas';
import { getConfiguracionSolicitudes } from 'api/nominas/solicitudes/configuracionDeSolicitudes';
import { getPercepcionesTiposDeNominas } from 'api/nominas/percepciones/percepcionesTiposDeNomina';
import { getPercepcionesTiposDeNominasEmpleados } from 'api/nominas/percepciones/percepcionesTiposDeNominaEmpleados';
import { getTiposDeNominasEmpleados } from 'api/nominas/catalogos/tiposNominasEmpleados';
import { checkToken } from 'api/utils';
import { getDatoOperacionalesDeEmpleados } from 'api/estructuraOrganizacional/datosOperacionalesDeEmpleados';
import {
  SLUG_PATTERN,
} from 'utils/patterns';

import { CheckCircleOutlined, CloseCircleOutlined, RedoOutlined } from '@ant-design/icons';
import ModalConfirmation from 'components/ModalConfirmation';
import CRUDgeneric from 'utils/CRUDgeneric';
import moment from 'moment';
import currencyFormatter from 'utils/currencyFormatter';
import SolicitudesPercepcionesEmpleados, { solicitudesPercepcionesEmpleadosPermission } from './SolicitudesPercepcionesEmpleados';
import SolcitudesPercepcionesEmpleadosDevolucion from './SolcitudesPercepcionesEmpleadosDevolucion';
import SolicitudesPercepcionesPeriodos from './SolicitudesPercepcionesPeriodos';

const { Text } = Typography;

export const solicitudesPercepcionesPermission = {
  permissionModel: 'solicitudpercepcion',
  catalogsModels: [],
  tabsModels: [],
};

const URI_CAMBIAR_ESTADOS = '/nominas/cambiar-estados-solicitudes-percepciones/';

const SolicitudesPercepciones = ({ permission }) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);
  const [percepciones, setPercepciones] = useState([]);
  const [percepcionSelected, setPercepcionSelected] = useState([]);
  const [periodicidades, setPeriodicidades] = useState([]);
  const [periodicidad, setPeriodicidad] = useState();
  const [periodosNominasDetalles, setPeriodosNominasDetalles] = useState([]);
  const [periodosNominas, setPeriodosNominas] = useState([]);
  const [solicitudes, setSolicitudes] = useState([]);
  const [solicitudesFiltered, setSolicitudesFiltered] = useState([]);
  const [parametrosSolicitud, setParametrosSolicitud] = useState([]);
  const [percepcionesTipoDeNomina, setPercepcionesTipoDeNomina] = useState([]);
  const [percepcionesTipoDeNominaEmpleado, setPercepcionesTipoDeNominaEmpleado] = useState([]);
  const [tiposDeNominas, setTiposDeNominas] = useState([]);
  const [tiposDeNominasEmpleados, setTiposDeNominasEmpleados] = useState([]);
  const [tipoParametro, setTipoParametro] = useState();
  const [selectedData, setSelectedData] = useState();
  const [disableAuth, setDisableAuth] = useState(false);
  const [deleteDisabled, setDeleteDisabled] = useState(false);
  const [visibleAuthConfirmation, setVisibleAuthConfirmation] = useState(false);
  const [visibleCancelar, setVisibleCancelar] = useState(false);
  const [visibleReactivar, setVisibleReactivar] = useState(false);
  const [selectedEstado, setSelectedEstado] = useState();
  const [visibleAlertInactive, setVisibleAlertInactive] = useState(false);
  const [disableColumn, setDisableColumn] = useState(false);
  const [disableImportePagar, setDisableImportePagar] = useState(false);
  const [aplicaDevolucionIsr, setAplicaDevolucionIsr] = useState(false);
  const disableColumnValues = [1, 2, 3, 5, 6];
  const disableImportePagarValues = [2, 3];
  const [isEditing, setIsEditing] = useState(false);
  const [datosOperacionales, setDatosOperacionales] = useState([]);
  const [solicitudConfig, setSolicitudConfig] = useState();

  const formatReceivedClone = (values) => {
    if (Array.isArray(values)) {
      let valueClone = values.map((e) => formatReceivedValues(e));
      valueClone = valueClone.map((e) => ({
        ...e,
        solicitud_percepcion: e?.solicitud,
        solicitud_periodicidad: e?.solicitud,
      }));
      return valueClone;
    }
    return formatReceivedValues(values);
  };

  const formInstances = [
    form,
  ];

  const getPermission = getModelPermission(
    solicitudesPercepcionesEmpleadosPermission.permissionModel,
    solicitudesPercepcionesEmpleadosPermission.catalogsModels,
    solicitudesPercepcionesEmpleadosPermission.tabsModels,
    false,
  );

  const fetchData = async () => {
    setLoading(true);
    const _data = await getSolicitudesPercepciones();
    setData(formatReceivedClone(_data));
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _datosOperacionales,
        _estados,
        _percepciones,
        _periodicidades,
        _periodosNominasDetalles,
        _periodosNominas,
        _solicitudes,
        _parametrosSolicitud,
        _tiposDeNominas,
        _tiposDeNominasEmpleados,
        _data,
      ] = await Promise.all([
        getDatoOperacionalesDeEmpleados(),
        getEstadosGlobales(),
        getPercepciones(),
        getPeriodicidadDePercepciones(),
        getPeriodosDeNominasDetalles(),
        getPeriodosDeNominas(),
        getConfiguracionSolicitudes(),
        getParametrosDeSolicitudes(),
        getTiposDeNomina(),
        getTiposDeNominasEmpleados(),
        getSolicitudesPercepciones(),
      ]);
      if (mounted) {
        setDatosOperacionales(_datosOperacionales);
        setEstados(_estados);
        setPercepciones(_percepciones);
        setPeriodicidades(_periodicidades);
        setPeriodosNominasDetalles(_periodosNominasDetalles.filter((periodo) => _periodosNominas.some((periodoNomina) => periodoNomina.id === periodo?.periodo_de_nomina)));
        setPeriodosNominas(_periodosNominas);
        setSolicitudes(_solicitudes);
        setSolicitudesFiltered(_solicitudes);
        // setSolicitudesFiltered(_solicitudes?.filter((e) => e?.estados_globales === ESTATUS_AUTORIZADO));
        setParametrosSolicitud(_parametrosSolicitud);
        setTiposDeNominas(_tiposDeNominas);
        setTiposDeNominasEmpleados(_tiposDeNominasEmpleados);
        setData(formatReceivedClone(_data));
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    setSelectedRowKeys([]);
    setVisible(false);
    setPeriodicidad();
    setTipoParametro();
    setSelectedData();
    setSelectedEstado();
    setIsEditing(false);
    setDisableAuth(false);
    form.resetFields();
  };

  const cambiarEstado = async (estadoDestino, setVisibleModal) => {
    try {
      setLoading(true);
      if (!selectedRowKeys.length) {
        setLoading(false);
        return;
      }
      const ids = selectedRowKeys.map((id) => ({ id }));
      const saved = await CRUDgeneric(URI_CAMBIAR_ESTADOS)
        .reemplazarRegistro(estadoDestino, ids);
      if (saved) {
        await fetchData();
        setVisibleModal(false);
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onConfirmCancelar = () => cambiarEstado(ESTATUS_CANCELADO, setVisibleCancelar);
  const onConfirmReactivar = () => cambiarEstado(ESTATUS_ACTIVO, setVisibleReactivar);

  const handleOnFinishConfirmation = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede Autorizar un Sindicato ya Autorizado');
        return;
      }
      const vals = {
        ...form.getFieldValue(),
        estados_globales: ESTATUS_AUTORIZADO,
      };
      const res = await patchSolicitudPercepcion(key, vals);
      if (res) {
        await fetchData();
        onSuccess(res);
        setVisibleAuthConfirmation(false);
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onClickEdit = async (responseData = null) => {
    setIsEditing(true);
    setLoading(true);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const _periodoNominaDetalle = periodosNominasDetalles.find((e) => e.id === match.periodo_de_nomina_detalle);
    const _periodoNomina = periodosNominas.find((e) => e.id === _periodoNominaDetalle?.periodo_de_nomina);
    const _selectedData = { tipo_de_nomina_empleado: _periodoNomina?.tipo_de_nomina_empleado, ...match };
    setSelectedData(_selectedData);
    const _solicitud = await getSolicitudPercepcion(match.id);
    const isAutorizado = _solicitud?.estados_globales === ESTATUS_AUTORIZADO;
    const isInactivo = _solicitud?.estados_globales === ESTATUS_INACTIVO;
    setDeleteDisabled(isAutorizado);
    setDisableAuth(isAutorizado || isInactivo);
    setTimeout(() => {
      if (_solicitud) {
        form.resetFields();
        setTimeout(() => {
          form.setFieldsValue(formatReceivedClone(_solicitud));
          const _soli = solicitudes.find((e) => e.id === _solicitud?.solicitud);
          const _percepcion = percepciones.find((e) => e.id === _soli.percepcion);
          setPercepcionSelected(_percepcion);
          setSolicitudConfig(_soli);
          const _tipoParametro = _soli?.solicitud_tipo_de_parametro;

          setPeriodicidad(percepciones.find((e) => e.id === _soli?.percepcion)?.periodicidad_de_percepcion);
          setAplicaDevolucionIsr(_percepcion?.es_devolucion_isr === true);
          setTipoParametro(_tipoParametro);

          // Desactivar columnas si se cumplen los casos
          setDisableColumn(disableColumnValues.includes(_tipoParametro) || _percepcion.aplica_importe_variable_por_evento === true);
          setDisableImportePagar(disableImportePagarValues.includes(_tipoParametro) || _percepcion.aplica_importe_variable_por_evento === true);

          getPercepcionesTiposDeNominas({ percepcion: _soli?.percepcion })
            .then((_data) => {
              setPercepcionesTipoDeNomina(_data);
            });
          getPercepcionesTiposDeNominasEmpleados({ percepcion: _soli?.percepcion })
            .then((_data) => {
              setPercepcionesTipoDeNominaEmpleado(_data);
            });
          setVisible(true);
        });
      }
    });
    setLoading(false);
  };

  const onFinish = async (_values, _continue = true) => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = {
        ...form.getFieldsValue(),
      };
      const [key] = selectedRowKeys;
      // eslint-disable-next-line max-len
      const saved = await (key ? patchSolicitudPercepcion(key, values) : postSolicitudPercepcion(values));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      const _periodoNominaDetalle = periodosNominasDetalles.find((e) => e.id === saved.periodo_de_nomina_detalle);
      const _periodoNomina = periodosNominas.find((e) => e.id === _periodoNominaDetalle?.periodo_de_nomina);
      const _selectedData = { tipo_de_nomina_empleado: _periodoNomina?.tipo_de_nomina_empleado, ...saved };
      setSelectedData(_selectedData);
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteSolicitudPercepcion(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    const isAutorizado = record?.estados_globales === ESTATUS_AUTORIZADO;
    const isInactivo = record?.estados_globales === ESTATUS_INACTIVO;
    setDeleteDisabled(isAutorizado);
    setDisableAuth(isAutorizado || isInactivo);
    setSelectedEstado(record?.estados_globales);
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    onCancel();
    form.setFieldsValue({
      fecha: moment(new Date().getDate(), 'DD/MM/YYYY'),
    });
    setPercepcionesTipoDeNomina([]);
    setPercepcionesTipoDeNominaEmpleado([]);
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const columns = [
    {
      titleText: 'Fecha de Captura',
      dataIndex: 'fecha',
      key: 'fecha',
      width: 200,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : ''),
    },
    {
      titleText: 'Clave de Configuración',
      dataIndex: 'solicitud',
      key: 'solicitud',
      width: 200,
      render: (val) => solicitudes.find((e) => e.id === val)?.clave,
    },
    {
      titleText: 'No. de Solicitud',
      dataIndex: 'folio_agrupador',
      key: 'folio_agrupador',
      width: 200,
    },
    {
      titleText: 'Percepción',
      dataIndex: 'solicitud_percepcion',
      key: 'solicitud_percepcion',
      width: 200,
      render: (val) => {
        const _solicitud = solicitudes.find((e) => e.id === val);
        const _percepcion = percepciones.find((e) => e.id === _solicitud?.percepcion);
        return `${_percepcion?.clave} - ${_percepcion?.descripcion}`;
      },
    },
    {
      titleText: 'Periodicidad',
      dataIndex: 'solicitud_periodicidad',
      key: 'solicitud_periodicidad',
      width: 200,
      render: (val) => {
        const _solicitud = solicitudes.find((e) => e.id === val);
        const _percepcion = percepciones.find((e) => e.id === _solicitud?.percepcion);
        return periodicidades.find((e) => e.id === _percepcion?.periodicidad_de_percepcion)?.descripcion;
      },
    },
    {
      titleText: 'Periodo de Pago',
      dataIndex: 'periodo_de_nomina_detalle',
      key: 'periodo_de_nomina_detalle',
      width: 250,
      render: (val) => {
        const _periodo = periodosNominasDetalles.find((e) => e.id === val);
        return `${_periodo?.numero_de_nomina} (${_periodo?.fecha_inicial} al ${_periodo?.fecha_final})`;
      },
    },
    {
      titleText: 'Parámetro',
      dataIndex: 'solicitud',
      key: 'solicitud',
      width: 200,
      render: (val) => {
        const _solicitud = solicitudes.find((e) => e.id === val);
        const _parametro = parametrosSolicitud.find((e) => e.id === _solicitud?.solicitud_tipo_de_parametro);
        return `${_parametro?.nombre}`;
      },
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 200,
      render: (val) => estados.find((e) => e.id === val)?.descripcion,
    },
  ];

  const columnsTipoNomina = [
    {
      titleText: 'Tipo de Nómina',
      dataIndex: 'tipo_de_nomina',
      key: 'tipo_de_nomina',
      width: 300,
      render: (val) => tiposDeNominas?.find((e) => e.id === val)?.descripcion,
    },
  ];

  const columnsTipoNominaEmpleado = [
    {
      titleText: 'Tipo de Nómina Empleado',
      dataIndex: 'tipo_de_nomina_empleado',
      key: 'tipo_de_nomina_empleado',
      width: 300,
      render: (val) => tiposDeNominasEmpleados?.find((e) => e.id === val)?.descripcion,
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    contratacion: [requiredRule],
    estatus: [requiredRule],
    clave: [
      requiredRule,
      {
        pattern: SLUG_PATTERN,
        message: 'Ingrese una clave válida',
      },
    ],
  };

  const onChangeSolicitud = async (value) => {
    if (value) {
      // Limpiamos el campo de periodo para evitar inconsistencias
      form.resetFields(['periodo_de_nomina_detalle']);

      // Buscamos la solicitud seleccionada
      const solicitudSeleccionada = solicitudes.find((e) => e.id === value);

      // Obtenemos y seteamos el tipo de parámetro de la solicitud
      setTipoParametro(solicitudSeleccionada?.solicitud_tipo_de_parametro);

      // Obtenemos la percepción asociada a la solicitud
      const percepcionAsociada = percepciones.find((e) => e.id === solicitudSeleccionada?.percepcion);

      // Seteamos la periodicidad que le corresponde a la percepción
      setPeriodicidad(percepcionAsociada?.periodicidad_de_percepcion);
      setAplicaDevolucionIsr(percepcionAsociada?.es_devolucion_isr === true);

      setSolicitudConfig(solicitudSeleccionada);
      setPercepcionSelected(percepcionAsociada);

      // Obtenemos los tipos de nómina y tipos de nómina empleados permitidos para esa percepción
      const tiposDeNomina = await getPercepcionesTiposDeNominas({ percepcion: solicitudSeleccionada?.percepcion });
      const tiposDeNominaEmpleado = await getPercepcionesTiposDeNominasEmpleados({ percepcion: solicitudSeleccionada?.percepcion });

      // Seteamos ambos catálogos para mostrarlos en la tabla
      setPercepcionesTipoDeNomina(tiposDeNomina);
      setPercepcionesTipoDeNominaEmpleado(tiposDeNominaEmpleado);

      // Obtenemos los IDs de tipo_de_nomina_empleado permitidos por la percepción
      const tiposPermitidos = tiposDeNominaEmpleado.map((p) => p.tipo_de_nomina_empleado);

      // Filtramos los periodos de nómina cuyo tipo_de_nomina_empleado coincida con los permitidos
      const periodosPermitidos = periodosNominas
        .filter((periodo) => tiposPermitidos.includes(periodo.tipo_de_nomina_empleado))
        .map((periodo) => periodo.id);

      // Finalmente, filtramos los detalles de periodos válidos para mostrar en el select
      const periodosFiltrados = periodosNominasDetalles.filter((periodo) => periodosPermitidos.includes(periodo.periodo_de_nomina));

      setPeriodosNominasDetalles(periodosFiltrados);
    } else {
      // Si no hay solicitud seleccionada, limpiamos los datos dependientes
      setPercepcionesTipoDeNomina([]);
      setPercepcionesTipoDeNominaEmpleado([]);
    }
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!open ? (
          <Table
            cols={columns}
            data={data}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            controls={{
              onClickAdd,
              onClickEdit: () => onClickEdit(),
              onClickDelete,
            }}
            permission={permission}
            allowExportPDF={false}
            customActions={[
              {
                onClick: () => setVisibleAuthConfirmation(true),
                permission: { model: 'solicitudpercepcion', action: 'autorizar' },
                text: 'Autorizar',
                icon: <CheckCircleOutlined />,
                disabledBySelection: false,
                className: 'success',
                // eslint-disable-next-line max-len
                disabled: !selectedRowKeys?.length || disableAuth,
              },
              {
                onClick: () => setVisibleCancelar(true),
                permission: { model: 'solicitudpercepcion', action: 'cancelar' },
                text: 'Cancelar',
                icon: <CloseCircleOutlined />,
                disabledBySelection: false,
                className: 'cancel',
                disabled: !selectedRowKeys?.length || selectedEstado === ESTATUS_CANCELADO,
              },
              {
                onClick: () => setVisibleReactivar(true),
                permission: { model: 'solicitudpercepcion', action: 'reactivar' },
                text: 'Reactivar',
                icon: <RedoOutlined />,
                disabledBySelection: false,
                className: 'success',
                disabled: !selectedRowKeys?.length || selectedEstado === ESTATUS_ACTIVO,
              },
            ]}
            disableDelete={
              deleteDisabled
            }
          />
        ) : (
          <Card
            className="form-container"
            title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Solicitud de Percepción`}
            extra={(
              <FormSubmitControls
                onFinish={() => form.submit()}
                onCancel={onCancel}
                loading={loading}
                onFinishText="Guardar y Continuar"
                allowSave={!selectedRowKeys?.length || !disableAuth}
              />
            )}
            bordered={false}
          >
            <Form
              layout="vertical"
              form={form}
              onFinish={onFinish}
              scrollToFirstError
              name="general"
              initialValues={{
                aplica_sueldo_promedio_del_periodo: false,
                se_resta_anticipo: false,
                aplica_calculo_piramidado: false,
                aplica_calculo_directo: false,
              }}

            >
              <Row gutter={10}>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="fecha"
                    label="Fecha de Captura"
                    hasFeedback
                  >
                    <DatePicker
                      allowClear
                      format="DD/MM/YYYY"
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="folio_agrupador"
                    label="No. de Solicitud"
                    hasFeedback
                  >
                    <Input
                      allowClear
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="solicitud"
                    label="Solicitud"
                    rules={rules.estatus}
                    hasFeedback
                  >
                    <Select
                      keyProp="id"
                      labelProp="clave"
                      dataSource={solicitudesFiltered}
                      onChange={onChangeSolicitud}
                      disabled={disableAuth || isEditing}
                      render={(value) => {
                        const _percepcion = percepciones.find((e) => e.id === value?.percepcion);
                        return `${value?.clave} - ${_percepcion?.clave} - ${_percepcion?.descripcion}`;
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    label="Periodicidad"
                    hasFeedback
                  >
                    <Select
                      dataSource={periodicidades}
                      value={periodicidad}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="periodo_de_nomina_detalle"
                    label="Periodo de Pago"
                    // rules={rules.required}
                    hasFeedback
                  >
                    <Select
                      keyProp="id"
                      labelProp="numero_de_nomina"
                      dataSource={periodosNominasDetalles}
                      disabled={disableAuth || isEditing}
                      render={(value) => `${value.numero_de_nomina} (${value.fecha_inicial} al ${value.fecha_final})`}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    label="Parámetro de Asignación de Percepción"
                    hasFeedback
                  >
                    <Select
                      keyProp="id"
                      labelProp="nombre"
                      dataSource={parametrosSolicitud}
                      value={tipoParametro}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item label="Importe Límite Máximo de Sueldo">
                    <Input
                      disabled
                      value={currencyFormatter(solicitudConfig?.importe_limite_maximo_sueldo || 0)}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={8}>
                  <Form.Item label="Tipo de Empleado">
                    <Input
                      disabled
                      value={
                        solicitudConfig?.aplica_tipo_nominas_empleados && solicitudConfig?.tipos_nominas_empleados?.length > 0
                          ? solicitudConfig.tipos_nominas_empleados.map((id) => tiposDeNominasEmpleados.find((t) => t.id === id)?.descripcion || '').filter(Boolean).join(', ')
                          : ''
                      }
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={8}>
                  <Form.Item label="Aplica Pago por Número de Días Laborados">
                    <Input
                      disabled
                      value={percepcionSelected?.aplica_pago_por_numero_de_dias_laborados ? 'SI' : 'NO'}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={8}>
                  <Form.Item label="Antigüedad Mínima">
                    <Input
                      disabled
                      value={solicitudConfig?.antiguedad_minima || 0}
                      addonAfter="Días"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="requiere_layout_carga"
                    label="Requiere Layout de Carga"
                    hasFeedback
                  >
                    <Select trueFalse />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="estados_globales"
                    label="Estatus"
                    rules={rules.estatus}
                    hasFeedback
                    initialValue={1}
                  >
                    <Select
                      labelProp="descripcion"
                      keyProp="id"
                      activeInactive={!deleteDisabled}
                      dataSource={estados}
                      disabled
                      onChange={(val) => {
                        if (val === ESTATUS_INACTIVO) {
                          setVisibleAlertInactive(true);
                        }
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              {aplicaDevolucionIsr && (
                <Row gutter={10}>

                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="aplica_sueldo_promedio_del_periodo"
                      label="Aplica Sueldo Promedio del Periodo"
                      hasFeedback

                    >
                      <Select trueFalse />
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      noStyle
                      shouldUpdate={(prev, curr) => prev.aplica_sueldo_promedio_del_periodo !== curr.aplica_sueldo_promedio_del_periodo}
                    >
                      {({ getFieldValue }) => (
                        <Form.Item
                          name="fecha_inicial_del_periodo_del_promedio"
                          label="Fecha Inicial del Periodo del Promedio"
                          hasFeedback
                        >
                          <DatePicker
                            allowClear
                            format="YYYY-MM-DD"
                            disabled={!getFieldValue('aplica_sueldo_promedio_del_periodo')}
                          />
                        </Form.Item>
                      )}
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      noStyle
                      shouldUpdate={(prev, curr) => prev.aplica_sueldo_promedio_del_periodo !== curr.aplica_sueldo_promedio_del_periodo}
                    >
                      {({ getFieldValue }) => (
                        <Form.Item
                          name="fecha_final_del_periodo_del_promedio"
                          label="Fecha Final del Periodo del Promedio"
                          hasFeedback
                        >
                          <DatePicker
                            allowClear
                            format="YYYY-MM-DD"
                            disabled={!getFieldValue('aplica_sueldo_promedio_del_periodo')}
                          />
                        </Form.Item>
                      )}
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="se_resta_anticipo"
                      label="Se Resta Anticipo"
                      hasFeedback

                    >
                      <Select trueFalse />
                    </Form.Item>
                  </Col>

                  {/* Solo mostrar si se_resta_anticipo = true */}
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      noStyle
                      shouldUpdate={(prev, curr) => prev.se_resta_anticipo !== curr.se_resta_anticipo}
                    >
                      {({ getFieldValue }) => (
                        <Form.Item
                          name="percepcion_del_anticipo"
                          label="Percepción del Anticipo"
                          hasFeedback
                        >
                          <Select
                            keyProp="id"
                            labelProp="clave"
                            dataSource={percepciones}
                            allowClear
                            disabled={!getFieldValue('se_resta_anticipo')}
                            render={(value) => `${value?.clave} ${value?.descripcion ? `- ${value.descripcion}` : ''}`}
                          />
                        </Form.Item>
                      )}
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="aplica_calculo_piramidado"
                      label="Aplica Cálculo Piramidado"
                      hasFeedback

                    >
                      <Select trueFalse />
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="aplica_calculo_directo"
                      label="Aplica Cálculo Directo"
                      hasFeedback

                    >
                      <Select trueFalse />
                    </Form.Item>
                  </Col>

                </Row>
              )}

              <Col xs={12} sm={12} md={12}>
                <Text style={{ color: '#D88F4F' }}>Periodos</Text>
                <SolicitudesPercepcionesPeriodos
                  selected={selectedData}
                  allowControls={!disableAuth}
                />
              </Col>
              <Row gutter={100} style={{ marginBottom: '2.5rem' }}>
                <Col xs={24} sm={24} md={12}>
                  <Text
                    style={
                      { color: '#D88F4F' }
                    }
                  >
                    Tipo de Nóminas
                  </Text>
                  <Table
                    cols={columnsTipoNomina}
                    data={percepcionesTipoDeNomina}
                    pagination={false}
                    allowExportParam={false}
                    mobileColIndex={0}
                  />
                </Col>
                <Col xs={24} sm={24} md={12}>
                  <Text style={{ color: '#D88F4F' }}>Tipo de Nómina Empleado</Text>
                  <Table
                    cols={columnsTipoNominaEmpleado}
                    data={percepcionesTipoDeNominaEmpleado}
                    pagination={false}
                    allowExportParam={false}
                    mobileColIndex={0}
                  />
                </Col>
              </Row>
              {selectedRowKeys.length ? (
                <Col>
                  <Text style={{ color: '#D88F4F' }}>
                    {tipoParametro === PARAMETRO_DEVOLUCION_DESCUENTOS_INDEBIDOS
                      ? 'Periodos de Descuentos Indebidos'
                      : 'Empleados'}
                  </Text>

                  {tipoParametro === PARAMETRO_DEVOLUCION_DESCUENTOS_INDEBIDOS ? (
                    <SolcitudesPercepcionesEmpleadosDevolucion
                      datosOperacionales={datosOperacionales}
                      permission={getPermission}
                      selected={selectedData}
                      percepcion={percepcionSelected}
                      allowControls={!disableAuth}
                    />
                  ) : (
                    <SolicitudesPercepcionesEmpleados
                      datosOperacionales={datosOperacionales}
                      permission={getPermission}
                      selected={selectedData}
                      tipoParametro={tipoParametro}
                      disableColumn={disableColumn}
                      disableImportePagar={disableImportePagar}
                      percepcion={percepcionSelected}
                      solicitudConfig={solicitudConfig}
                      requiereLayoutCarga={selectedData?.requiere_layout_carga}
                      allowControls={!disableAuth}
                    />
                  )}
                </Col>
              ) : null}

              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Form>
          </Card>
        )}
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`Solicitud de Percepción ${form.getFieldValue('folio_agrupador')}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={() => setVisibleAlertInactive(false)}
          ConfirmInactive
          onCancel={() => {
            setVisibleAlertInactive(false);
            form.setFieldValue('estados_globales', ESTATUS_ACTIVO);
          }}
          open={visibleAlertInactive}
          contentTitle={`Inactivar la Solicitud de Percepción ${form.getFieldValue('folio_agrupador')}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishConfirmation}
          ConfirmAutorize
          onCancel={() => {
            setVisibleAuthConfirmation(false);
            onCancel();
          }}
          open={visibleAuthConfirmation}
          contentTitle={`Autorizar la Solicitud de Percepción ${form.getFieldValue('folio_agrupador')}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={onConfirmCancelar}
          ConfirmCancel
          onCancel={() => setVisibleCancelar(false)}
          open={visibleCancelar}
          contentTitle={`Cancelar la Solicitud de Percepción ${form.getFieldValue('folio_agrupador')}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={onConfirmReactivar}
          onFinishText="Reactivar"
          onFinishIcon={<RedoOutlined />}
          onCancel={() => setVisibleReactivar(false)}
          open={visibleReactivar}
          contentTitle={`Reactivar la Solicitud de Percepción ${form.getFieldValue('folio_agrupador')}`}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default SolicitudesPercepciones;
